/**
 * Javascript file for recommendation card.
 * @author Yannik Sprengart, Andrea Villeda
 */

export default {
    name: "RecCard",

    /**
     * The vue instance's data object.
     */
    data() {
        return {};
    },
};


// WEBPACK FOOTER //
// ./src/components/company/kirc/components/recommendationcard.js